<script>
import {setLang} from "../../i18n";
import moment from "moment";

export default {
    name: "LangSelector",
    data: () => ({
        languages: [
            { title: 'English', value: 'en' },
            { title: 'Français', value: 'fr' },
        ]
    }),
    methods: {
        changeLang(lang) {
            setLang(lang);
            this.$i18n.locale = lang;
            moment.locale(lang);
        }
    }
}
</script>

<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-btn
                icon
                v-on="on"
                class="primary--text"
            >
                <v-icon>mdi-translate</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-tile
                v-for="(lang, index) in languages"
                :key="index"
                @click="changeLang(lang.value)"
                :disabled="lang.value === $i18n.locale"
            >
                <v-list-tile-title>{{ lang.title }}</v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>
